<h1 mat-dialog-title>Cambiar contraseña</h1>

<div mat-dialog-content>

  <form [formGroup]="changePasswordForm">

    <div fxLayout="column">

      <mat-form-field>
        <mat-label>Contraseña</mat-label>
        <input matInput formControlName="password" type="password">
        <mat-error *ngIf="changePasswordForm.controls.password.hasError('required')">
           Contraseña es <strong>obligatoria</strong>
        </mat-error>
        <mat-error *ngIf="changePasswordForm.controls.password.hasError('minlength')">
            Contraseña ha de ser al menos de <strong>8 caracteres</strong>
        </mat-error>
        <mat-error *ngIf="changePasswordForm.controls.password.hasError('maxlength')">
            Contraseña no ha de ser de mas de <strong>50 caracteres</strong>
        </mat-error>
        <mat-error *ngIf="changePasswordForm.controls.password.hasError('pattern') && !(changePasswordForm.controls.password.hasError('minlength') || changePasswordForm.controls.password.hasError('maxlength'))">
            Contraseña ha de incluir un <strong>número primo</strong> y al menos <strong>una mayúscula</strong> ,<strong>una minúscula y un caracter especial</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Repetir Contraseña</mat-label>
        <input matInput formControlName="repeatPassword" type="password">
        <mat-error *ngIf="changePasswordForm.controls.repeatPassword.hasError('required')">
            Contraseña es <strong>obligatoria</strong>
        </mat-error>
        <mat-error *ngIf="changePasswordForm.controls.repeatPassword.hasError('notequal')">
            Contraseñas <strong>no coinciden</strong>
        </mat-error>
      </mat-form-field>

    </div>

  </form>

</div>

<mat-dialog-actions align="center">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="warn" [disabled]="!changePasswordForm.valid" [mat-dialog-close]="{password:changePasswordForm.get('password').value,repeatPassword:changePasswordForm.get('repeatPassword').value}">Confirm</button>
</mat-dialog-actions>
